module.exports = __webpack_public_path__ + "img/footer-img.07b4fd94.webp";